/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type MyGooseGameQuestLogsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type MyGooseGameQuestLogsQuery = {
  myGooseGameQuestLogs: Array<
    Pick<Types.GooseGameQuestLog, "id" | "quest_id" | "created_at">
  >;
};

export const MyGooseGameQuestLogsDocument = gql`
  query MyGooseGameQuestLogs {
    myGooseGameQuestLogs {
      id
      quest_id
      created_at
    }
  }
`;

/**
 * __useMyGooseGameQuestLogsQuery__
 *
 * To run a query within a React component, call `useMyGooseGameQuestLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyGooseGameQuestLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyGooseGameQuestLogsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyGooseGameQuestLogsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    MyGooseGameQuestLogsQuery,
    MyGooseGameQuestLogsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    MyGooseGameQuestLogsQuery,
    MyGooseGameQuestLogsQueryVariables
  >(MyGooseGameQuestLogsDocument, baseOptions);
}
export function useMyGooseGameQuestLogsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    MyGooseGameQuestLogsQuery,
    MyGooseGameQuestLogsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    MyGooseGameQuestLogsQuery,
    MyGooseGameQuestLogsQueryVariables
  >(MyGooseGameQuestLogsDocument, baseOptions);
}
export type MyGooseGameQuestLogsQueryHookResult = ReturnType<
  typeof useMyGooseGameQuestLogsQuery
>;
export type MyGooseGameQuestLogsLazyQueryHookResult = ReturnType<
  typeof useMyGooseGameQuestLogsLazyQuery
>;
export type MyGooseGameQuestLogsQueryResult = ApolloReactCommon.QueryResult<
  MyGooseGameQuestLogsQuery,
  MyGooseGameQuestLogsQueryVariables
>;
